import { createFileRoute } from '@tanstack/react-router';
import { LandMonitoringProperties } from '@/components/land-monitoring-properties';
import { usePermissions } from '@/hooks/use-permissions';
import { PERMISSIONS } from '@property/shared';

export const Route = createFileRoute('/dashboard/land-monitoring/')({
  component: LandMonitoringPage,
});

function LandMonitoringPage() {
  const { can } = usePermissions();
  if (!can(PERMISSIONS.PROPERTIES_READ)) return null;
  return <LandMonitoringProperties />;
}
